module.exports = ".modal-dialog {\n  overflow-y: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bulk-renewal/component/bulk-renewal-request/renewal-modal/renewal-modal.component.scss
// module id = ./src/app/bulk-renewal/component/bulk-renewal-request/renewal-modal/renewal-modal.component.scss
// module chunks = main